import { useController, UseControllerProps } from 'react-hook-form'
import useReactHookFormError from './useReactHookFormError'
import { AutocompleteProps, TextFieldProps } from '@mui/material'
import React from 'react'
import { TOption } from './OWSelect'
import { SelectorWithInput } from './Inputs/SelectorWithInput'

export interface IGroupOptions extends TOption {
    groupValue?: string
}
export type SelectorProps = Omit<
    AutocompleteProps<TOption, true, boolean, true>,
    'renderInput' | 'onChange' | 'isOptionEqualToValue' | 'value' | 'groupBy'
> &
    TextFieldProps & {
        label?: string
        options: TOption[]
        hasEmpty?: boolean
        isGroupLetter?: boolean
        loading?: boolean
        resetValue?: any
        value: any
        onChange?: (value: any) => void
        onChangeCallback?: (value: any) => void
        selectFirstValue?: boolean
        error?: boolean
        helperText?: string
        sortLabel?: boolean
        emptyLabel?: string
        onCustomChange?: (event: any) => void
    }

function OWAutocomplete<T extends object>(
    props: UseControllerProps<T> & Omit<SelectorProps, 'value'>,
) {
    const { name, control, rules, onCustomChange, ...compProps } = props
    const {
        field,
        formState: { errors },
    } = useController<T>({ name, control, rules })

    const error = useReactHookFormError(errors, name)

    const { ref, value, onChange, ...otherFields } = field

    return (
        <SelectorWithInput
            {...compProps}
            {...otherFields}
            {...error}
            value={value}
            onChange={onCustomChange ?? onChange}
        />
    )
}

export default OWAutocomplete
